import dropdownConstants from '../constants';
import CCFormDropdownOptionsFilter from './_Filter';
import CCFormDropdownOptionsOption from './_Option';
import computeClassName from "../../../../../../utils/computeClassName";
import {useState} from "react";

const constants = Object.freeze({
  CLASSNAME_BASE: 'max-h-60 z-10 overflow-y-auto list-none absolute w-full top-100 bg-cc-white text-cc-gray-100 border border-cc-accent rounded-b-lg shadow-cc-lg -mt-px',
  CLASSNAME_DROPDOWN_SIZE: {
    [dropdownConstants.SIZE_XSMALL]: 'py-1',
    [dropdownConstants.SIZE_SMALL]: 'py-1.25',
    [dropdownConstants.SIZE_MEDIUM]: 'py-1.25',
    [dropdownConstants.SIZE_LARGE]: 'py-1.5'
  },
  CLASSNAME_NO_MATCHES_FOUND_TEXT_LIST_ITEM_DROPDOWN_SIZE: {
    [dropdownConstants.SIZE_XSMALL]: 'px-2 py-1',
    [dropdownConstants.SIZE_SMALL]: 'px-3 py-1.25',
    [dropdownConstants.SIZE_MEDIUM]: 'px-4 py-1.25',
    [dropdownConstants.SIZE_LARGE]: 'px-4 py-1.5'

  }
});

function getComputedClassName(propsClassName, dropdownSize) {
  return computeClassName(propsClassName, `${constants.CLASSNAME_BASE} ${constants.CLASSNAME_DROPDOWN_SIZE[dropdownSize]}`);
}

function getComputedNoMatchesFoundListItemClassName(dropdownSize) {
  return computeClassName('', `${constants.CLASSNAME_NO_MATCHES_FOUND_TEXT_LIST_ITEM_DROPDOWN_SIZE[dropdownSize]}`);

}

export default function CCFormDropdownOptions(
  {
    dropdownSize,
    dropdownAllowMultipleSelection,
    dropdownOptionList,
    dropdownOptionKeyLabel,
    dropdownOptionKeyValue,
    dropdownOptionKeyIsDisabled,
    dropdownOptionKeyIsGroup,
    dropdownOptionKeyIsSelected,
    dropdownOptionSelectFn,
    dropdownOptionUnselectFn,
    dropdownIsLTR,
    dropdownIsFilterable,
    dropdownFilterNoMatchesFoundText,
    dropdownFilterPlaceholderText,
    className = ''
  }
) {
  const computedClassName = getComputedClassName(className, dropdownSize);
  const computedNoMatchesFoundListItemClassName = getComputedNoMatchesFoundListItemClassName(dropdownSize);

  const [filterValue,setFilterValue] = useState('');
  const [filteredDropdownOptions, setFilteredDropdownOptions] = useState([...dropdownOptionList]);

  function updateFilterValue(newFilterValue) {
    const validatedNewFilterValue = !newFilterValue ? '' : newFilterValue.toLowerCase();
    setFilterValue(previousValue => validatedNewFilterValue );
    if (!!validatedNewFilterValue.length) {
      const filteredOptions = dropdownOptionList.filter(dropdownOption => dropdownOption[dropdownOptionKeyLabel].toLowerCase().startsWith(validatedNewFilterValue));
      setFilteredDropdownOptions( previousValue => [...filteredOptions]);
    }
    else {
      setFilteredDropdownOptions( previousValue => [...dropdownOptionList]);
    }
  }

  function clearFilterValue() {
    setFilterValue(previousValue => '');
    setFilteredDropdownOptions( previousValue => [...dropdownOptionList]);
  }



  return (
    <ul className={computedClassName}
        role="listbox"
        aria-expanded="true">
      {
        !!dropdownIsFilterable &&
          <li>
            <CCFormDropdownOptionsFilter dropdownSize={dropdownSize}
                                         filterPlaceholderText={dropdownFilterPlaceholderText}
                                         filterValue={filterValue}
                                         filterValueOnChangeFn={updateFilterValue}
                                         filterValueOnClearFn={clearFilterValue}/>
          </li>
      }
      {
        filteredDropdownOptions.map((dropdownOption, index) => {
          return <CCFormDropdownOptionsOption key={index}
                                              dropdownOption={dropdownOption}
                                              dropdownAllowMultipleSelection={dropdownAllowMultipleSelection}
                                              dropdownSize={dropdownSize}
                                              dropdownOptionKeyLabel={dropdownOptionKeyLabel}
                                              dropdownOptionKeyValue={dropdownOptionKeyValue}
                                              dropdownOptionKeyIsDisabled={dropdownOptionKeyIsDisabled}
                                              dropdownOptionKeyIsGroup={dropdownOptionKeyIsGroup}
                                              dropdownOptionKeyIsSelected={dropdownOptionKeyIsSelected}
                                              dropdownOptionSelectFn={dropdownOptionSelectFn}
                                              dropdownOptionUnselectFn={dropdownOptionUnselectFn}
                                              dropdownIsLTR={dropdownIsLTR}
          />
        })
      }
      {
        !!dropdownIsFilterable && !filteredDropdownOptions.length &&
        <li className={computedNoMatchesFoundListItemClassName}>{dropdownFilterNoMatchesFoundText}</li>
      }
    </ul>
  );
}
